import styled from "styled-components"; 


export const Container = styled.div`
    ${({error}) => {
            if(error){
                return (
                `
                textarea {
                    border: 1px solid red;
                    &::placeholder {
                        padding-left: 10px;
                    }
                }
                p {
                    visibility: visible;
                }
                `
                )
            }
        }}

     height: max-content !important;
`;


export const TxtArea = styled.textarea`
    width: 300px;
    height: ${({height}) => height};
    background-color: var(--color-grey97);
    border: 1px solid var(--color-grey90);
    padding-left: 10px;
    padding-top: 10px;
`;

export const Title = styled.span`
     font-weight: bold;
`;

export const MsjError = styled.p`
    color: red; 
    visibility: hidden;
`;